export class WhatsappModel {

    code: string
    number: string

  
    constructor(obj: any = null) {
      this.code = obj?.code
      this.number = obj?.number
    }
  }